import {
    RequestMessageDefinition,
    RespondMessageDefinition,
} from "userful-chronos-app-common-js/dist/message/messageModel";

const CARBON = 5500;
const CARBON_BACKUP = 5501;
const GCM_CLUSTER_CODE = 5502;
const GCM_REMOTE_MANAGEMENT = 5503;

export const NOTIFY_CLUSTER_INFO_UPDATED = new RespondMessageDefinition(CARBON, 0);
export const NOTIFY_CLUSTER_UNPAIR = new RespondMessageDefinition(CARBON, 1);
export const NOTIFY_CLUSTER_DASHBOARD_UPDATE = new RespondMessageDefinition(CARBON, 2);

export const NOTIFY_CLUSTER_BACKUP_CREATED = new RespondMessageDefinition(CARBON_BACKUP, 0);
export const NOTIFY_CLUSTER_BACKUP_DELETED = new RespondMessageDefinition(CARBON_BACKUP, 1);

export const NOTIFY_CLUSTER_CODE_CONSUMED = new RespondMessageDefinition(GCM_CLUSTER_CODE, 0);

export const REQUEST_REMOTE_CONNECTION = new RequestMessageDefinition(GCM_REMOTE_MANAGEMENT, 0);
export const RESPOND_REMOTE_CONNECTION = new RespondMessageDefinition(GCM_REMOTE_MANAGEMENT, 0);
